import { ComparisonEntry } from '@comparison/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { Category } from '@spartacus/core';
import { ComparisonState, StateWithComparison } from '../comparison-state';
import { getComparisonState } from './feature.selector';

export const getComparisonFeatureState: MemoizedSelector<StateWithComparison, ComparisonState> = createSelector(
  getComparisonState,
  (state) => state,
);

export const getComparisonEntries: MemoizedSelector<StateWithComparison, ComparisonEntry[]> = createSelector(
  getComparisonState,
  (state) => state.entries,
);

export const getComparisonLoading: MemoizedSelector<StateWithComparison, { [productId: string]: boolean }> =
  createSelector(getComparisonState, (state) => state.loading);

export const getComparisonEntryLoading = (productId: string): MemoizedSelector<StateWithComparison, boolean> =>
  createSelector(getComparisonLoading, (loading) => loading[productId] || false);

export const getComparisonLastAddedCategoryCode: MemoizedSelector<StateWithComparison, string> = createSelector(
  getComparisonEntries,
  (entries) => entries[entries.length - 1]?.category.code,
);

export const getComparisonLastAddedCategoryEntriesCount: MemoizedSelector<StateWithComparison, number> = createSelector(
  [getComparisonEntries, getComparisonLastAddedCategoryCode],
  (entries, code) => (entries as ComparisonEntry[]).filter((entry) => entry.category.code === code).length,
);

export const getComparisonActiveCategory: MemoizedSelector<StateWithComparison, string> = createSelector(
  getComparisonState,
  (state) => state.activeCategory,
);

export const getComparisonHasEntry = (productId: string): MemoizedSelector<StateWithComparison, boolean> =>
  createSelector(getComparisonEntries, (entries) => entries?.some((entry) => entry.productId === productId));

export const getComparisonSortedCategories: MemoizedSelector<StateWithComparison, Category[]> = createSelector(
  getComparisonState,
  (state) => {
    return state.sortedCategory;
  },
);
